declare global {
  var __STATS_TEST_CLEANUPS__: Set<() => void> | undefined
}

export function registerStatsTestCleanup(cleanup: () => void): void {
  if (process.env.NODE_ENV === 'test' || isStorybook()) {
    globalThis.__STATS_TEST_CLEANUPS__ ??= new Set()
    globalThis.__STATS_TEST_CLEANUPS__.add(cleanup)
  }
}

function isStorybook(): boolean {
  try {
    return process.env.APP_ENV === 'storybook'
  } catch (error) {
    if (error instanceof ReferenceError) return false
    throw error
  }
}
